import { FormField } from '@/components/data/dataType';
import { z } from 'zod';
import { isValidPhoneNumber } from 'react-phone-number-input';

export const getFieldValidation = (field: FormField, locale: string) => {
    let schema:
        | z.ZodString
        | z.ZodNumber
        | z.ZodBoolean
        | z.ZodDate
        | z.ZodAny
        | z.ZodOptional<z.ZodString>
        | z.ZodOptional<z.ZodNumber>
        | z.ZodOptional<z.ZodBoolean>
        | z.ZodOptional<z.ZodDate>
        | z.ZodOptional<z.ZodAny>
        | z.ZodEffects<z.ZodString>
        | z.ZodOptional<z.ZodEffects<z.ZodString>>;

    switch (field.dataType) {
        case 'string':
            schema = z.string({
                required_error:
                    (field.requiredMessage && field.requiredMessage[locale]) ||
                    `${field.name} is required`,
            });
            break;
        case 'number':
            schema = z.number({
                required_error:
                    (field.requiredMessage && field.requiredMessage[locale]) ||
                    `${field.name} is required`,
                invalid_type_error:
                    (field.invalidMessage && field.invalidMessage[locale]) ||
                    `${field.name} must be a number`,
            });
            break;
        case 'boolean':
            schema = z.boolean({
                required_error:
                    (field.requiredMessage && field.requiredMessage[locale]) ||
                    `${field.name} is required`,
                invalid_type_error:
                    (field.invalidMessage && field.invalidMessage[locale]) ||
                    `${field.name} must be a boolean`,
            });
            break;
        case 'email':
            schema = z
                .string({
                    required_error:
                        (field.requiredMessage &&
                            field.requiredMessage[locale]) ||
                        `${field.name} is required`,
                })
                .email({
                    message:
                        (field.invalidMessage &&
                            field.invalidMessage[locale]) ||
                        `${field.name} is not a valid email`,
                });
            break;
        case 'phone':
            schema = z
                .string({
                    required_error:
                        (field.requiredMessage &&
                            field.requiredMessage[locale]) ||
                        'Ce champ est requis.',
                })
                .refine(
                    value => isValidPhoneNumber(value),
                    (field.invalidMessage && field.invalidMessage[locale]) ||
                        'Numéro de téléphone invalide.',
                );
            break;
        case 'date':
            schema = z
                .string({
                    required_error: 'La date est obligatoire.',
                    invalid_type_error: 'La date doit être valide.',
                })
                .regex(
                    /^\d{4}-\d{2}-\d{2}$/,
                    'La date doit être au format YYYY-MM-DD.',
                )
                .refine(value => !isNaN(Date.parse(value)), {
                    message: 'La date doit être une date valide.',
                });
            break;
        default:
            schema = z.any();
            break;
    }

    if (!field.required) {
        schema = schema.optional();
    }

    return schema;
};
